import React from "react"
import Desktop from "./Desktop"
import { ResponsiveLayout } from "components"

const Login = (props: any) => {
  return (
    <ResponsiveLayout
      mobileView={<Desktop {...props} />}
      desktopView={<Desktop {...props} />}
    />
  )
}

export default Login
